import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import Modal from 'Components/Modal';
import LottieLoader from 'Components/LottieLoader';
import ReactPlayer from 'react-player';
import Image from 'Components/Image';
import assetUrl from 'Utils/assetUrl';

const getModal = props => {
  return (
    <Modal
      className="horse-racing-mediplayer-modal"
      onClose={ props.onClose }
      title={ '' }
    >
      { props.type === 'video' && <div className='horse-racing-media-player-wrapper'>
        <ReactPlayer
          controls
          className='horse-racing-media-player'
          playing={ true }
          playIcon
          url={ props.url }
          width='100%'
          height='100%'
        />
      </div> }
  
      { props.type === 'image'
       && <Image
         src={ props.url }
         className="help-page-image-wrapper"
         loader={
           <LottieLoader type="loading" loop={ true } autoplay width="30px" />
         }
         unloader={
           <img src={ assetUrl('bilyoner.png') } alt="Bilyoner" />
         }
       /> }

    </Modal>
  );

};

const FAQRowMediaContent = ({ data }) => {
  const filteredData = data?.filter(e=> e.url && e.fileType);
  const [modal, setModal] = useState(null);

  if (!filteredData) {
    return null;
  }

  return (
    <div>
      { modal && getModal(modal) }
      <div className='faq-media-wrapper'>
        {
          filteredData.map(e=>{
            if (e.fileType === 'video') {
              return (
                <Button
                  title= { 'Video yu Aç' }
                  key={ e.url }
                  className="btn--primary btn--round "
                  onClick={ () =>  {
                    setModal({ type: 'video', url: e.url, onClose: () => setModal(null) });
                  } }>
                  { "Video'yu Aç" }
                </Button>
              );
            }

            return (
              <Button
                title= { 'Fotoğrafı Aç' }
                key={ e.url }
                className="btn--primary btn--round"
                onClick={ () =>  {
                  setModal({ type: 'image', url: e.url, onClose: () => setModal(null) });

                } }>
                { 'Fotoğrafı Aç' }
              </Button>
            );
          }
          )
        }
      </div>
    </div>
  );
};


FAQRowMediaContent.propTypes = {
  data: PropTypes.array,
};

export default FAQRowMediaContent;
